module.exports = __webpack_public_path__ + "media/react/layouts/components/notice_banner/assets/sale_tag_icon-a06bdb409c9f436c15b00285bafb1d02.svg";